var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.781 13.629l-3.664-3.664c.793-.957 1.23-2.188 1.23-3.527C12.348 3.32 9.778.75 6.66.75 3.516.75 1 3.32 1 6.438c0 3.144 2.543 5.687 5.66 5.687a5.59 5.59 0 003.527-1.23l3.665 3.664c.136.136.3.191.492.191a.544.544 0 00.437-.191c.274-.246.274-.657 0-.93zM2.312 6.438a4.37 4.37 0 014.376-4.375 4.388 4.388 0 014.375 4.374 4.37 4.37 0 01-4.376 4.375 4.353 4.353 0 01-4.375-4.374z",
    fill: "#ADB5BD"
  })));
}
export default SvgSearch;